import * as ActionTypes from "../constants/actionTypes"
import { IOngoingDoctorConsultation } from "../interfaces/ongoingConsultation/IOngoingDoctorConsultation"
import { OngoingDoctorConsultationActionNames } from "../constants/actionTypes"
import { IMedicalProfile } from "../interfaces/patient/IMedicalProfile"

function init(): IOngoingDoctorConsultation {
	return {} as IOngoingDoctorConsultation
}

export const ongoingDoctorConsultationReducer = (state = init(), action: any): IOngoingDoctorConsultation => {
	switch (action.type) {
		case ActionTypes.OngoingDoctorConsultationActionNames.APPOINTMENT_DATA_FETCH_SUCCESS:
			return {
				...state,
				appointment: action.payload,
			}
		case ActionTypes.OngoingDoctorConsultationActionNames.MEDICAL_PROFILE_DATA_FETCH_SUCCESS:
			return {
				...state,
				medicalProfile: action.payload,
			}
		case ActionTypes.OngoingDoctorConsultationActionNames.USER_PROFILE_DATA_FETCH_SUCCESS:
			return {
				...state,
				personalProfile: action.payload,
			}
		case ActionTypes.OngoingDoctorConsultationActionNames.USER_ATTRIBUTES_DATA_FETCH_SUCCESS:
			return {
				...state,
				userAttributes: action.payload,
			}
		case OngoingDoctorConsultationActionNames.PATIENT_VITALS_FETCH_SUCCESS:
			return {
				...state,
				patientVitals: action.payload,
			}
		case OngoingDoctorConsultationActionNames.PAST_PRESCRIPTIONS_FETCH_SUCCESS:
			return {
				...state,
				pastPrescriptions: action.payload,
			}
		case OngoingDoctorConsultationActionNames.PRESCRIPTION_ADHERENCE:
			return {
				...state,
				adherenceSummary: action.payload,
			}
		case OngoingDoctorConsultationActionNames.PRESCRIPTION_ACTIVE_GOALS:
			return {
				...state,
				goals: action.payload,
			}
		case OngoingDoctorConsultationActionNames.PRESCRIPTION_ACTIVE_GOALS_IN_PDF:
			return {
				...state,
				removeGoalsFromPdf: action.payload,
			}
		case OngoingDoctorConsultationActionNames.PRESCRIPTION_ADHERENCE_IN_PDF:
			return {
				...state,
				removeAdherenceFromPdf: action.payload,
			}
		case OngoingDoctorConsultationActionNames.UPDATE_DOCTOR_CONSULTATION_DATA:
			return {
				...state,
				...(action.payload || {}),
			}
		case OngoingDoctorConsultationActionNames.FETCH_PATIENT_IN_CENTER_DATA_SUCCESS:
			return {
				...state,
				...(action.payload || {}),
			}
		case OngoingDoctorConsultationActionNames.CLEAR_ONGOING_CONSULTATION_DATA:
			return init()
		case OngoingDoctorConsultationActionNames.PATIENT_MEDICINE_PRESCRIPTION_FETCH_SUCCESS:
			return {
				...state,
				medicalProfile: {
					...(state?.medicalProfile || ({} as any)),
					currentData: {
						...(state?.medicalProfile?.currentData || {}),
						prescriptionMedicines: action.payload,
					},
				},
			}
		case OngoingDoctorConsultationActionNames.UPDATE_APPOINTMENT_STATUS:
			return {
				...state,
				appointment: {
					...(state.appointment || ({} as any)),
					status: action.payload,
				},
			}
		case OngoingDoctorConsultationActionNames.UPDATE_AI_PRESCRIPTION_SUGGESTIONS:
			return {
				...state,
				aiPrescriptionSuggestions: action.payload,
			}
		default:
			return state
	}
}
